module.exports = __webpack_public_path__ + "static/media/cor.3b2e8332.jpeg";